'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M344 80c-31.5 0-61.4 7.3-88 20.4-26.6-13-56.5-20.4-88-20.4-10 0-19.9 .7-29.6 2.2-16.4-17.2-26.4-40.5-26.4-66.2l0-16 48 0c53 0 96 43 96 96 0-53 43-96 96-96l48 0 0 16c0 25.6-10.1 48.9-26.4 66.2-9.6-1.4-19.5-2.2-29.6-2.2zM168 112c31.9 0 61.7 8.9 87.1 24.3l.9 .5c48 29.6 80 82.6 80 143.1l32 0c0-64.8-30.8-122.4-78.6-158.9 17.1-5.9 35.5-9.1 54.6-9.1 92.8 0 168 75.2 168 168 0 152-256 232-256 232S0 432 0 280c0-92.8 75.2-168 168-168z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;